<div class="row" style="margin-top: 10px;height: 65vh;overflow-y: scroll;">
  <div class="medium-12 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">Plan Name*</div>
      <div style="flex:1">
        <label>
          <input type="text" [(ngModel)]="newTaxPlan.name" placeholder="Plan Name"/>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-6 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">Total Tax*</div>
      <div style="flex:1">
        <label>
          <input type="text" placeholder="Total Tax" [(ngModel)]="newTaxPlan.totalTax" model-numeral [format]="'$0,0.00'" [locale]="'usd'" (blur)="calculateEffectiveRate()"/>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-6 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">Taxable Income*</div>
      <div style="flex:1">
        <label>
          <input type="text" placeholder="Taxable Income" [(ngModel)]="newTaxPlan.taxableIncome" model-numeral [format]="'$0,0.00'" [locale]="'usd'" (blur)="calculateEffectiveRate()"/>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-12 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">
        Effective Rate(%)*
        <span style="font-size: 12px; color: #1570EF;">Calculated based using (Total tax / Total taxable income)</span>
      </div>
      <div style="flex:1">
        <label>
          <input type="text" placeholder="24" [(ngModel)]="newTaxPlan.effectiveRate"/>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-6 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">
        <span class="text-center">Marginal Rate(%)*</span>
        <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showRatesInfo()"></i>
              <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
                Click here to link to current marginal tax rates
              </span>
            </span>
      </div>
      <div style="flex:1">
        <label>
          <input type="text" placeholder="21" [(ngModel)]="newTaxPlan.marginalRate"/>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-6 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">
        <span class="text-center">Cap Gains Rate(%)*</span>
        <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showRatesInfo()"></i>
              <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">
                Click here to link to current cap gains tax rates
              </span>
            </span>
      </div>
      <div style="flex:1">
        <label>
          <input type="text" placeholder="22" [(ngModel)]="newTaxPlan.capGainRate"/>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-6 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">C Corp Flat Rate(%)*</div>
      <div style="flex:1">
        <label>
          <input type="text" placeholder="21" [(ngModel)]="newTaxPlan.ccropFlatRate"/>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-6 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">Tax Plan Year*</div>
      <div style="flex:1">
        <label>
          <app-tpiq-select-dropdown [setData]="years" [includeNone]="false" (onValueSelect)="setYear($event)"
                                 [setDefaultValue]="newTaxPlan.taxYear || ''" [setSearchKey]="'name'" [setPlaceHolder]="'Tax Plan Year'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-12 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">
        <span class="text-center">Home State*</span>
      </div>
      <div style="flex:1">
        <label>
          <app-tpiq-select-dropdown [setData]="states" [setPlaceHolder]="'Select State'" [includeNone]="false" [setSearchKey]="'name'" [setValueKey]="'short'" [setDefaultValue]="newTaxPlan.homeState"
                                 (onValueSelect)="onHomeStateSelect($event)"></app-tpiq-select-dropdown>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-6 column">
    <div class="address-bar row-margin">
      <div style="flex:2">
        <span class="text-center" class="popup-label">Individual State Rate(%)</span>
        <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showStateRatesInfo('individual')"></i>
              <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">Click here to link to current individual state rates</span>
            </span>
      </div>
      <div style="flex:1">
        <label>
          <input type="text" placeholder="10" [(ngModel)]="newTaxPlan.individualStateRate"/>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-6 column">
    <div class="address-bar row-margin">
      <div style="flex:2">
        <span class="text-center" class="popup-label">Corporate State Rate(%)</span>
        <span class="text-center badge-tooltip">
              <i class="icon ion-ios-information-outline" (click)="showStateRatesInfo('corporate')"></i>
              <span class="bottomTooltiptext" style="width: 175px; margin-left: -85px;">Click here to link to current corporate state rates</span>
            </span>
      </div>
      <div style="flex:1">
        <label>
          <input type="text" placeholder="10" [(ngModel)]="newTaxPlan.corporateStateRate"/>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-12 column">
    <div class="address-bar row-margin">
      <div style="flex:2" class="popup-label">Description</div>
      <div style="flex:1">
        <label>
          <div style="min-height:50px;border:1px solid #cacaca;padding:10px;margin-bottom:20px;" [froalaEditor]="editorOptions" [(froalaModel)]="newTaxPlan.description"></div>
        </label>
      </div>
    </div>
  </div>
  <div class="medium-12 column" style="background: rgba(234, 236, 240, 0.5);border-radius: 4px;padding-bottom: 15px;">
    <div class="address-bar row-margin">
      <span class="pointer popup-label" style="color: #1570EF" (click)="addCustomTaxRate()"><i class="icon ion-ios-plus-outline"></i>Custom Rate</span>
    </div>
    <div class="row address-bar row-margin" *ngFor="let customTaxRate of newTaxPlan.customTaxRates;let idx = index">
      <div class="medium-6 columns">
        <div style="flex:2">
          <input type="text" class="custom-tax-rate-name" placeholder="Tax Rate Name" [(ngModel)]="customTaxRate.name"/>
        </div>
      </div>
      <div class="medium-6 columns">
        <div style="flex:1">
          <input type="text" class="custom-tax-rate" placeholder="25" [(ngModel)]="customTaxRate.rate"/>
          <span class="pointer custom-rate-remove" (click)="removeCustomTaxRate(idx)"><i class="icon ion-ios-trash-outline"></i></span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row" style="margin-top: 20px;">
  <div class="medium-12">
    <button class="button small float-right" [ngStyle]="{'background': (newTaxPlan && newTaxPlan.name) ? '#1570EF':'#98A2B3'}" (click)="createTaxPlan()">Create</button>
    <button class="button small float-right" style="border: 1px solid #D0D5DD;border-radius: 6px;background: #FFFFFF;color:#333333;" (click)="closeCreatePlanPopup()">Cancel</button>
  </div>
</div>
